<template>
  <div class="welcome">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'WelcomeLayout',
}
</script>

<style lang="sass" scoped>
.welcome
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  height: 100vh
  padding: 20px
  background-color: #fafafa

.fade-enter-active, .fade-leave-active
  transition: opacity 0.5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
